import React from "react"
import Helmet from "react-helmet"
import { graphql, Link } from "gatsby"
import Layout from "../components/layout"
import PostLink from "../components/post-link"

export default function TermTemplate({ data, pageContext }) {
  const { site, allMarkdownRemark } = data
  const posts = allMarkdownRemark.edges.filter(({ node }) => {
    const { category, tags } = node.frontmatter

    if (pageContext.termType === "category") {
      return category === pageContext.term
    }

    return tags && tags.includes(pageContext.term)
  })

  return (
    <Layout>
      <Helmet>
        <title>{pageContext.title} | {site.siteMetadata.title}</title>
        <meta name="description" content={`${pageContext.title} posts on ${site.siteMetadata.title}`} />
      </Helmet>
      <section className="page-header">
        <p className="eyebrow">{pageContext.termType}</p>
        <h1>{pageContext.title}</h1>
        <p>{posts.length} post{posts.length === 1 ? "" : "s"} found.</p>
      </section>
      <div className="grids">
        {posts.map(({ node }) => (
          <PostLink key={node.id} post={node} />
        ))}
      </div>
      <div className="post-actions">
        <Link to="/" className="button">Back to all posts</Link>
      </div>
    </Layout>
  )
}

export const pageQuery = graphql`
  query TermPageQuery {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(
      sort: { order: DESC, fields: [frontmatter___date] }
      filter: { frontmatter: { draft: { ne: true }, date: { ne: null } } }
    ) {
      edges {
        node {
          id
          excerpt(pruneLength: 250)
          frontmatter {
            date(formatString: "YYYY年MM月DD日")
            path
            title
            thumbnail
            category
            tags
          }
        }
      }
    }
  }
`
